/* Hydrate the server-rendered inline TOC without moving article content. */
document.addEventListener('DOMContentLoaded', () => {
  const prose = document.querySelector('.article .article-content > .prose');
  if (!prose) return;
  const nav = prose.querySelector('[data-article-toc-inline]');
  if (!nav || nav.dataset.initialized) return;
  nav.dataset.initialized = 'true';

  const headings = [...prose.querySelectorAll('h2, h3')];
  const links = [...nav.querySelectorAll('.article-toc__link')];
  const headingLinks = new Map();
  links.forEach((link) => {
    const heading = headings[Number(link.dataset.headingIndex)];
    if (!heading) return;
    if (!heading.id) heading.id = link.hash.slice(1);
    link.setAttribute('href', `#${heading.id}`);
    headingLinks.set(heading, link);
    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const top = window.scrollY + heading.getBoundingClientRect().top - window.innerHeight * 0.35;
      window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  });
  if ('IntersectionObserver' in window) {
    let active;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        active?.classList.remove('is-active');
        active?.removeAttribute('aria-current');
        active = headingLinks.get(entry.target);
        active?.classList.add('is-active');
        active?.setAttribute('aria-current', 'location');
      });
    }, { rootMargin: '-120px 0px -60% 0px', threshold: 0 });
    headingLinks.forEach((link, heading) => observer.observe(heading));
  }
  // Restore a direct heading link after assigning IDs, without shifting the TOC.
  if (location.hash) {
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
    if (target && headingLinks.has(target)) requestAnimationFrame(() => target.scrollIntoView());
  }
});

/* Add the scroll container required by the wide-table styles. */
(() => {
  const wrapWideArticleTables = () => {
    document.querySelectorAll('.article-content > .prose table').forEach((table) => {
      const firstRow = table.rows[0];
      if (!firstRow || firstRow.cells.length < 6 || table.closest('.table-wrap')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrap';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', 'Tableau comparatif déroulant');
      table.before(wrapper);
      wrapper.appendChild(table);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapWideArticleTables, { once: true });
  } else {
    wrapWideArticleTables();
  }
})();
